const apiKey = import.meta.env.VITE_AUTHENTICATION_API_KEY;

if (!apiKey) {
  throw new Error("API Key is missing from environment variables.");
}

const createInstance = async (instanceName: any): Promise<any> => {
  try {
    const response = await fetch('https://evolutionapi.cabanalink.com/instance/create', {
      method: 'POST',
      headers: {
        apikey: apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        instanceName,
        token: '',
        qrcode: true,
        integration: "WHATSAPP-BAILEYS",
        readStatus: false,
        webhook: {
          enabled: true,
          events: [
            "QRCODE_UPDATED",
            "CONNECTION_UPDATE",
          ],
          url: "https://nextalk.cabanalink.com/webhook",
        },
        sqs: {
          enabled: true,
          events: ["APPLICATION_STARTUP"]
        },
      })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Erro ao criar instancia:', error);
    throw error;
  }
}

export default createInstance;